export default {
  title: "CBAM 快速查询",
  subtitle: {
    noReg: "无需注册",
    free: "免费",
    minutes: "1 分钟",
  },
  steps: {
    country: "国家",
    product: "商品",
    volume: "进口量",
    result: "结果",
  },
  step1: {
    title: "您是从欧盟外进口到欧盟，还是欧盟内贸易？",
    outsideEU: "欧盟外进口",
    insideEU: "欧盟内（豁免）",
  },
  step2: {
    title: "主要进口商品？（多选支持）",
    steel: "钢铁",
    aluminum: "铝",
    cement: "水泥",
    fertilizer: "化肥",
    electricity: "电力",
    hydrogen: "氢",
    other: "其他",
  },
  step3: {
    title: "2026 年预计欧盟进口量？",
    lt50t: "< 50 吨（豁免）",
    between50_500t: "50–500 吨",
    gt500t: "> 500 吨",
  },
  result: {
    lowRisk: "低风险",
    mediumRisk: "中风险",
    highRisk: "高风险",
    insideEU: "恭喜！欧盟内贸易豁免，无需报告/付费。但建议监控变化。",
    outsideEU: "恭喜！年 < 50 吨豁免或非覆盖商品，无需报告/付费。但建议监控变化。",
    highRiskDesc: "必须报告 + 购买证书（基于排放），误差 > 10% 罚款 €1K–€10K。",
    mediumRiskDesc: "需季度报告，2026 起可能付费。推荐生成 PwC 格式报告避风险。",
  },
  whyChoose: {
    title: "为什么选择 TaxEcoBit？",
    description: "TaxEcoBit 帮您 90%+ 精度计算，3 秒出合规 PDF/Excel。",
    features: {
      accurate: "精准合规：误差 <10%，符合 CBAM 要求",
      fast: "快速出报告：3 秒生成合规 PDF/Excel",
      cost: "成本优势：€99/月，远低于竞品 €500+/月",
      trial: "免费试用 14 天，体验所有高级功能",
    },
  },
  newRule: "2026 新规：年 < 50 吨豁免（氢/电力除外），但报告仍需精准避罚款。",
  buttons: {
    prev: "上一步",
    next: "下一步",
    viewResult: "查看结果",
    generateReport: "生成完整报告（免费注册/试用）",
    restart: "重新开始",
  },
};
